<div class="row" *ngIf="showUploadSection">
  <div class="HmsContainer">
    <div class="row main-home py-0">
      <div class="col-md-12 button-padding-left">
        <p role="heading" aria-level="1" class="padding-left-0">Upload File(s)</p>
      </div>
    </div>

    <form id="attachmentAddForm" #attachmentAddForm="ngForm">
      <input
        id="attachmentAddModified"
        type="hidden"
        value="{{ attachmentAddForm?.dirty }}"
      />
      <div class="row padding-10">
        <div
          id="addFileDiv"
          class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
          fileDragDrop
          (filesChangeEmiter)="handleFileSelect($event)">
          <div class="row title">
            <div class="col-md-12 button-padding-left">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#dc3545" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16" style="margin-right: 8px; vertical-align: top;margin-left:-25px;">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
              </svg>
              <p style="font-size: 1.1em; display: inline;">{{ permanentInstructionalText }}</p>
              <br/><br/>
              <p role="heading" aria-level="2" class="padding-left-0">{{ uploadInstructionalText }}</p>
            </div>
          </div>
          <input
            type="file"
            name="file"
            id="file"
            class="inputfile"
            multiple
            (click)="clearFileInput($event)"
            (change)="onFileChange($event)"
          />
          <label
            id="fileLabel"
            name="fileLabel"
            for="file"
            class="darkNavy-fc title3"
          >
            <svg xmlns="http://www.w3.org/2000/svg" [attr.fill]="primaryColor" class="bi bi-cloud-arrow-up-fill uploadImage"
              viewBox="0 0 16 16">
              <path
                d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0z" />
            </svg>
            <br />
            You can drag and drop images to upload<br />
            <label
              id="fileLabel"
              name="fileLabel"
              for="file"
              class="uploadButton orangeBtn"
              [ngStyle]="{'background-color': primaryColor}"
              >Browse Computer</label
            >
          </label>
          <span class="error validation-color" [innerHtml]="error"></span>
        </div>
        <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 button-padding-left-list">
          <div class="title">Files Selected For Upload</div>
          <div class="row titleWellStatus">
            <div
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 p-1 displayBackgroundColor"
            >
              <strong>Action</strong>
            </div>
            <div
              class="col-xs-6 col-sm-6 col-md-6 col-lg-6 p-1 displayBackgroundColor"
            >
              <strong>File Name</strong>
            </div>
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 p-1 displayBackgroundColor"
            >
              <strong>File Size</strong>
            </div>
          </div>
          <div class="height-300-overflow-auto" tabindex="0">
            <div
              *ngFor="let newAttachment of FilesToUpload"
              class="row fileList"
            >
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 fs-13">
                <button type="button" class="orangeBtn ml-5" [ngStyle]="{'background-color': primaryColor}"
                 (click)="removeFile(newAttachment)">Remove</button>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 fs-13">
                {{ newAttachment.fileName }}
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 fs-13">
                <span class="pull-right">{{ newAttachment.sizeReadable }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<hr />
<ngx-spinner type="ball-scale-multiple" name="file-upload"></ngx-spinner>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  name="file-upload"
  ><div class="flex-column">
    <p class="font-20-white">
      File(s) upload is in progress. Closing the web browser in the meantime
      will cause the upload(s) to fail.
    </p>
    <div class="form-group col-xs-6 col-sm-6 col-md-8 col-lg-8 bgcolor-white" *ngIf="showFileUploadStatus">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 flex-row-status">
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 padding-8">
          <strong>File Name</strong>
        </div>
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 padding-8">
          <strong>File Size</strong>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 padding-8">
          <strong>Status</strong>
        </div>
      </div>
      <div class="auto-height-overflowy" tabindex="0">
        <div
          *ngFor="let newAttachment of FilesToUpload"
          class="fileList flex-display"
        >
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 fs-13 padding-8">
            {{ newAttachment.fileName }}
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 fs-13 padding-8">
            <span class="pull-right">{{ newAttachment.sizeReadable }}</span>
          </div>
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 fs-13 padding-8">
            <span
              class="pull-right"
              *ngIf="
                newAttachment.percentage == 100 &&
                newAttachment.failureToUpload == false
              "
              >Upload complete</span
            >
            <span
              class="pull-right"
              *ngIf="
                newAttachment.percentage != 100 &&
                newAttachment.percentage != 500 &&
                newAttachment.percentage != 600
              "
              >Upload in progress</span
            >
            <span
              class="pull-right"
              *ngIf="
                newAttachment.percentage != 100 &&
                newAttachment.percentage != 500 &&
                newAttachment.percentage == 600
              "
              >Error in upload</span
            >
            <span
              class="pull-right"
              *ngIf="
                newAttachment.percentage != 100 &&
                newAttachment.percentage == 500 &&
                newAttachment.percentage != 600
              "
              >Upload failed. Please rename the file completely and try again.</span
            >
          </div>
        </div>
      </div>
    </div>
    <div>
      <br/>
    </div>
    <div *ngIf="hasErrorInUpload && !showReUploadModal">
      <button type="button" class="orangeBtn ml-5" [ngStyle]="{'background-color': primaryColor}"
                 (click)="removeAndReplaceErrorFiles()">Remove/Replace All Errored Uploads</button>
    </div>
  </div>
  <div style="background-color: white;" *ngIf="showReUploadModal">
    <input
        id="attachmentAddModified"
        type="hidden"
        value="{{ attachmentAddForm?.dirty }}"
      />
      <div class="row padding-10">
        <div
          id="addFileDiv"
          class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
          fileDragDrop
          (filesChangeEmiter)="handleFileSelect($event)">
          <div class="row title">
            <div class="col-md-12 button-padding-left">
              <p role="heading" aria-level="1" class="padding-left-0">Remove/Replace Attachments</p>              
              <p role="heading" aria-level="2" class="padding-left-0" style="font-weight: normal;">{{ reUploadInstructionalText }}</p>
            </div>
          </div>
          <input
            type="file"
            name="file"
            id="file"
            class="inputfile"
            multiple
            (click)="clearFileInput($event)"
            (change)="onFileChange($event)"
          />
          <label
            id="fileLabel"
            name="fileLabel"
            for="file"
            class="darkNavy-fc title3"
          >
            <svg xmlns="http://www.w3.org/2000/svg" [attr.fill]="primaryColor" class="bi bi-cloud-arrow-up-fill uploadImage"
              viewBox="0 0 16 16">
              <path
                d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0z" />
            </svg>
            <br />
            You can drag and drop images to upload<br />
            <label
              id="fileLabel"
              name="fileLabel"
              for="file"
              class="uploadButton orangeBtn"
              [ngStyle]="{'background-color': primaryColor}"
              >Browse Computer</label
            >
          </label>
          <span class="error validation-color" [innerHtml]="error"></span>
        </div>
        <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
          <div class="title">Files Selected For Upload</div>
          <div class="row titleWellStatus">
            <div
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 p-1 displayBackgroundColor"
            >
              <strong>Action</strong>
            </div>
            <div
              class="col-xs-6 col-sm-6 col-md-6 col-lg-6 p-1 displayBackgroundColor"
            >
              <strong>File Name</strong>
            </div>
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 p-1 displayBackgroundColor"
            >
              <strong>File Size</strong>
            </div>
          </div>
          <div class="height-300-overflow-auto" tabindex="0">
            <div
              *ngFor="let newAttachment of FilesToUpload"
              class="row fileList"
            >
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 fs-13">
                <span class="pull-right" *ngIf="newAttachment.percentage == 100">Upload complete</span>
                <button type="button" class="orangeBtn ml-5" *ngIf="newAttachment.percentage != 100" [ngStyle]="{'background-color': primaryColor}"
                 (click)="removeFile(newAttachment)">Remove</button>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 fs-13">
                {{ newAttachment.fileName }}
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 fs-13">
                <span class="pull-right">{{ newAttachment.sizeReadable }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; flex-direction: row-reverse;">
          <button type="button" class="orangeBtn ml-5" [ngStyle]="{'background-color': primaryColor}"
                 (click)="reUploadNewFiles()">Submit</button>
        </div>
      </div>
  </div>
</ngx-spinner>
